// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".obj-recipe-step__settings p[data-v-21880238]{margin-top:15px}", ""]);
// Exports
module.exports = exports;
